var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"nav"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/"}},[_vm._v("Тренажёр")]),_c('router-link',{staticClass:"nav-link",attrs:{"to":"/stats"}},[_vm._v("Статистика")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }